<div class="mb-3 img-wrap position-relative user-summary-avatar-editor">
  <div class="img-clip bg-gradient-grey user-summary-avatar-frame">
    <button
      type="button"
      class="btn btn-sm btn-primary user-summary-avatar-action"
      [disabled]="isUploading()"
      (click)="selectAvatar(avatarInput)">
      Change
    </button>
    @if (uploadProgress() !== null) {
      <div class="progress user-summary-avatar-progress">
        <div
          class="progress-bar"
          role="progressbar"
          [style.width.%]="uploadProgress()"></div>
      </div>
    }
    <img
      class="w-100"
      [src]="currentUser()?.avatarUrl()"
      (error)="currentUser()?.handleImageError()"
      alt="User avatar" />
    <input
      #avatarInput
      type="file"
      class="d-none"
      accept="image/png,image/jpeg,image/webp"
      (change)="avatarSelected($event)" />
  </div>
</div>